const components = {
  dailyReport: {
    loading: 'Đang tải báo cáo hàng ngày...',
    fetchError: 'Không thể tải dữ liệu báo cáo hàng ngày.',
    retry: 'Thử lại',
    close: 'Đóng',
    title: 'B Á O   C Á O   N G À Y',
    subtitle: 'Daily Production Report',
    reportDate: 'Ngày báo cáo',
    category: 'Phân loại',
    author: 'Người lập',
    createdAt: 'Thời gian tạo',
    section1: '1. Tình trạng thiết bị (Trong ngày)',
    section2: '2. Hiệu quả sản xuất',
    section3: '3. Phân tích OEE',
    section4: '4. Phân tích tổng hợp & Đề xuất',
    colItem: 'Hạng mục',
    colQtyRatio: 'Số lượng/Tỷ lệ',
    colQty: 'Số lượng',
    colUnit: 'Đơn vị',
    colNote: 'Ghi chú',
    totalEquipment: 'Tổng số thiết bị',
    totalEquipmentNote: 'Tổng thiết bị đã đăng ký',
    avgOperationRate: 'Tỷ lệ vận hành TB ngày',
    avgOperationRateNote: 'Tỷ lệ vận hành tổng ngày',
    totalShots: 'Tổng số shot trong ngày',
    totalShotsNote: 'Tổng số lần ép',
    alarmCount: 'Số cảnh báo phát sinh',
    alarmCountNote: 'Tổng cảnh báo trong ngày',
    goodProduction: 'Sản lượng đạt',
    goodProductionNote: 'Sản phẩm đạt trong ngày',
    defectCount: 'Số lỗi',
    defectCountNote: 'Lỗi trong ngày',
    totalProduction: 'Tổng sản lượng',
    totalProductionNote: 'Đạt + Lỗi',
    energyUsage: 'Lượng năng lượng sử dụng',
    energyUsageNote: 'Lượng điện sử dụng',
    unitDae: 'cái',
    unitPercent: '%',
    unitTimes: 'lần',
    unitCount: 'lần',
    unitPiece: 'cái',
    oeeIndicator: 'Chỉ số',
    oeeValue: 'Giá trị',
    oeeProgress: 'Tiến độ',
    oeeRating: 'Đánh giá',
    availability: 'Tính sẵn sàng (Availability)',
    performance: 'Hiệu suất (Performance)',
    quality: 'Chất lượng (Quality)',
    overallOee: 'OEE tổng hợp',
    ratingGood: 'Tốt',
    ratingAverage: 'Trung bình',
    ratingNeedsImprovement: 'Cần cải thiện',
    ratingExcellent: 'Xuất sắc',
    oeeFormula: '* OEE = Tính sẵn sàng x Hiệu suất x Chất lượng',
    pdfGenerating: 'Đang tạo PDF...',
    pdfSave: 'Lưu PDF',
    pdfFailed: 'Tạo PDF thất bại. Vui lòng thử lại.',
    autoFooter: 'Báo cáo này được tạo tự động.',
    fileName: 'BaoCaoNgay_{category}_{date}.pdf',
  },
  weeklyReport: {
    loading: 'Đang tải báo cáo tuần...',
    fetchError: 'Không thể tải dữ liệu báo cáo tuần.',
    retry: 'Thử lại',
    close: 'Đóng',
    title: 'B Á O   C Á O   T U Ầ N',
    subtitle: 'Weekly Production Report',
    reportDate: 'Ngày báo cáo',
    category: 'Phân loại',
    author: 'Người lập',
    createdAt: 'Thời gian tạo',
    section1: '1. Tình trạng thiết bị (Tuần)',
    section2: '2. Hiệu quả sản xuất (Tuần)',
    section3: '3. Phân tích OEE (TB tuần)',
    section4: '4. Phân tích tổng hợp & Đề xuất (Tuần)',
    avgOperationRate: 'Tỷ lệ vận hành TB tuần',
    avgOperationRateNote: 'Tỷ lệ vận hành tổng tuần',
    totalShots: 'Tổng số shot trong tuần',
    alarmCountNote: 'Tổng cảnh báo trong tuần',
    goodProductionNote: 'Sản phẩm đạt trong tuần',
    defectCountNote: 'Lỗi trong tuần',
    pdfFailed: 'Tạo PDF thất bại. Vui lòng thử lại.',
    fileName: 'BaoCaoTuan_{category}_{startDate}_{endDate}.pdf',
  },
  monthlyReport: {
    loading: 'Đang tải báo cáo tháng...',
    fetchError: 'Không thể tải dữ liệu báo cáo tháng.',
    retry: 'Thử lại',
    close: 'Đóng',
    title: 'B Á O   C Á O   T H Á N G',
    subtitle: 'Monthly Production Report',
    yearMonth: 'Tháng {month}/{year}',
    reportDate: 'Ngày báo cáo',
    category: 'Phân loại',
    author: 'Người lập',
    createdAt: 'Thời gian tạo',
    section1: '1. Tình trạng thiết bị (Tháng)',
    section2: '2. Hiệu quả sản xuất (Tháng)',
    section3: '3. Phân tích OEE (TB tháng)',
    section4: '4. Phân tích tổng hợp & Đề xuất (Tháng)',
    avgOperationRate: 'Tỷ lệ vận hành TB tháng',
    avgOperationRateNote: 'Tỷ lệ vận hành tổng tháng',
    totalShots: 'Tổng số shot trong tháng',
    alarmCountNote: 'Tổng cảnh báo trong tháng',
    goodProductionNote: 'Sản phẩm đạt trong tháng',
    defectCountNote: 'Lỗi trong tháng',
    pdfFailed: 'Tạo PDF thất bại. Vui lòng thử lại.',
    fileName: 'BaoCaoThang_{category}_{year}-{month}.pdf',
  },
  monitoringWatch1: {
    cols: {
      moldClose: 'Đóng khuôn',
      moldProtect: 'Bảo vệ khuôn',
      highPressure: 'Áp cao',
      moldOpen: 'Mở khuôn',
      injectionComplete: 'Hoàn tất ép',
      cycleTime: 'Thời gian chu kỳ',
      extrusion: 'Đẩy ra',
      moldOpenComplete: 'Hoàn tất mở khuôn',
      maxInjectionPressure: 'Áp ép max',
      holdingPressure: 'Áp giữ',
      holdingTransfer: 'Chuyển áp giữ',
      cushionAmount: 'Đệm',
      injectionStart: 'Bắt đầu ép',
      metering: 'Định lượng',
      suckbackTime: 'Thời gian hút lùi',
    },
  },
  monitoringWatch2: {
    cols: {
      no: 'STT',
      shotCount: 'Số shot',
      cycleTime: 'Thời gian chu kỳ',
      injHoldTime: 'Thời gian giữ áp',
      chargeTime: 'Thời gian định lượng',
      injStartPosi: 'Bắt đầu ép',
      turnPosi: 'Bắt đầu áp giữ',
      injEndPosi: 'Đệm',
      fetchTime: 'Thời gian lấy',
    },
  },
  lstmDefect: {
    sectionAttention: 'Phân tích Attention Weight theo khoảng thời gian',
    sectionFactor: 'Mức độ quan trọng của yếu tố gây lỗi',
    sectionParamTrend: 'Xu hướng tham số chính (50 shot gần nhất)',
    sectionRadar: 'So sánh trạng thái tham số',
    sectionRecommendations: 'Đề xuất tinh chỉnh quy trình',
    sectionConfidence: 'Độ tin cậy của mô hình',
    loading: 'Đang tải...',
    noData: 'Không có dữ liệu',
    missingIds: 'Thiếu ID thiết bị hoặc ID khuôn.',
    anomalySummary: '* Điểm bất thường: {score} | Ngưỡng: {threshold} |',
    anomalyDetected: ' Phát hiện bất thường',
    anomalyNormal: ' Bình thường',
    importance: 'Mức độ quan trọng: {value}%',
    overallConfidence: 'Độ tin cậy tổng thể',
    lstmAccuracy: 'Độ chính xác dự đoán LSTM',
    attentionConfidence: 'Độ tin cậy Attention',
    dataQuality: 'Chỉ số chất lượng dữ liệu',
    radarNormal: 'Khoảng bình thường (+/-5%)',
    radarCurrent: 'Hiện tại',
    radarOptimal: 'Đề xuất',
    paramTrend: {
      cushion: 'Đệm (mm)',
      cushionLabel: 'Đệm',
      nozzleTemp: 'Nhiệt độ vòi (°C)',
      nozzleTempLabel: 'Nhiệt độ vòi',
      maxPress: 'Áp ép tối đa (bar)',
      maxPressLabel: 'Áp ép tối đa',
    },
  },
  dynamicChart: {
    unsupported: 'Loại biểu đồ không được hỗ trợ: {type}',
  },
  modal: {
    defaultTitle: 'Xác nhận xóa',
    defaultMessage: 'Bạn có chắc chắn muốn xóa?',
    defaultConfirm: 'Xóa',
    defaultCancel: 'Hủy',
  },
  tableRenderer: {
    noData: 'Không có dữ liệu bảng.',
    truncated: '* Hiển thị {displayed} dòng (tổng: {total})',
  },
  pagination: {
    info: '{start}-{end} / {total}',
    sizeOption: '{n} mỗi trang',
    first: 'Đầu',
    previous: 'Trước',
    next: 'Sau',
    last: 'Cuối',
  },
};

export default components;
